/**
 * KeepsakeHaus Custom Enhancements
 * 1. Collection list carousel arrows
 * 2. Random social proof numbers
 */

document.addEventListener('DOMContentLoaded', function() {

  // ===== 1. CAROUSEL ARROWS (Desktop) & DOTS (Mobile) =====
  const carousels = document.querySelectorAll('.collection-list-wrapper');
  const isMobile = window.innerWidth < 750;

  carousels.forEach(wrapper => {
    const list = wrapper.querySelector('.collection-list');
    if (!list || list.children.length <= 4) return;

    // Find the section container (outside scroll area)
    const section = wrapper.closest('.shopify-section');
    if (!section) return;

    // Create a fixed container for arrows
    const arrowContainer = document.createElement('div');
    arrowContainer.className = 'carousel-arrow-container';

    // Create prev arrow
    const prevBtn = document.createElement('button');
    prevBtn.className = 'carousel-arrow carousel-arrow--prev';
    prevBtn.setAttribute('aria-label', 'Previous');
    prevBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 18l-6-6 6-6"/></svg>`;

    // Create next arrow
    const nextBtn = document.createElement('button');
    nextBtn.className = 'carousel-arrow carousel-arrow--next';
    nextBtn.setAttribute('aria-label', 'Next');
    nextBtn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18l6-6-6-6"/></svg>`;

    arrowContainer.appendChild(prevBtn);
    arrowContainer.appendChild(nextBtn);

    // Insert arrow container as first child of section
    section.style.position = 'relative';
    section.insertBefore(arrowContainer, section.firstChild);

    // Make list scrollable, not wrapper
    list.style.overflowX = 'auto';
    list.style.scrollBehavior = 'smooth';
    list.style.scrollbarWidth = 'none';
    list.style.msOverflowStyle = 'none';

    const scrollAmount = list.firstElementChild ? list.firstElementChild.offsetWidth + 24 : 300;

    prevBtn.addEventListener('click', () => {
      list.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      list.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });

    // Update arrow visibility
    function updateArrows() {
      const atStart = list.scrollLeft <= 10;
      const atEnd = list.scrollLeft >= (list.scrollWidth - list.clientWidth - 10);
      prevBtn.style.opacity = atStart ? '0.3' : '1';
      prevBtn.style.pointerEvents = atStart ? 'none' : 'auto';
      nextBtn.style.opacity = atEnd ? '0.3' : '1';
      nextBtn.style.pointerEvents = atEnd ? 'none' : 'auto';
    }

    list.addEventListener('scroll', updateArrows);
    setTimeout(updateArrows, 100);
  });

  // ===== 1B. MOBILE DOTS PAGINATION =====
  if (isMobile) {
    carousels.forEach(wrapper => {
      const list = wrapper.querySelector('.collection-list');
      if (!list || list.children.length <= 2) return;

      const items = list.querySelectorAll('.collection-list__item');
      const itemCount = items.length;

      // Calculate visible items (approximately 2 on mobile with 45% width)
      const visibleItems = 2;
      const totalPages = Math.ceil(itemCount / visibleItems);

      if (totalPages <= 1) return;

      // Create dots container
      const dotsContainer = document.createElement('div');
      dotsContainer.className = 'mobile-dots';

      for (let i = 0; i < totalPages; i++) {
        const dot = document.createElement('button');
        dot.className = 'mobile-dot' + (i === 0 ? ' active' : '');
        dot.setAttribute('aria-label', `Page ${i + 1}`);
        dot.dataset.page = i;

        dot.addEventListener('click', () => {
          const scrollTarget = (list.scrollWidth / totalPages) * i;
          list.scrollTo({ left: scrollTarget, behavior: 'smooth' });
        });

        dotsContainer.appendChild(dot);
      }

      wrapper.appendChild(dotsContainer);

      // Update active dot on scroll
      list.addEventListener('scroll', () => {
        const scrollPercent = list.scrollLeft / (list.scrollWidth - list.clientWidth);
        const activePage = Math.round(scrollPercent * (totalPages - 1));

        dotsContainer.querySelectorAll('.mobile-dot').forEach((dot, index) => {
          dot.classList.toggle('active', index === activePage);
        });
      });
    });
  }

  // ===== 2. RANDOM SOCIAL PROOF =====
  const socialProofElements = document.querySelectorAll('.product__text, .product__description');

  socialProofElements.forEach(el => {
    const text = el.innerHTML;
    // Match "X people bought this today" pattern
    if (text.includes('people bought this today')) {
      const randomNum = Math.floor(Math.random() * 10) + 3; // 3-12
      el.innerHTML = text.replace(/\d+\s*people bought this today/, randomNum + ' people bought this today');
    }
  });

  // Also check for standalone social proof text
  const allText = document.body.innerHTML;
  const socialProofPattern = /(\d+)\s*people bought this today/g;

  document.querySelectorAll('p, span, div').forEach(el => {
    if (el.children.length === 0 || el.classList.contains('product__text')) {
      const text = el.textContent;
      if (text && text.includes('people bought this today') && !el.dataset.randomized) {
        const randomNum = Math.floor(Math.random() * 10) + 3;
        el.innerHTML = el.innerHTML.replace(/\d+\s*people bought this today/, randomNum + ' people bought this today');
        el.dataset.randomized = 'true';
      }
    }
  });
});
